import React, { useState } from 'react';
import { Box, Paper, Typography, Tabs, Tab } from '@mui/material';

// Import the 3 new dedicated files
import GeneratePayslips from './GeneratePayslips';
import PayslipApprovals from './PayslipApprovals';
import PayslipReport from './PayslipReport';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return <div hidden={value !== index} {...other}>{value === index && <Box sx={{ pt: 3 }}>{children}</Box>}</div>;
}

const PayslipManagement = () => {
  const [currentTab, setCurrentTab] = useState(0);

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
      <Paper elevation={3} sx={{ borderRadius: 3, p: 3 }}>
        <Typography variant="h6" color="primary" sx={{ fontWeight: 'bold', mb: 2 }}>PAYSLIP</Typography>
        
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={currentTab} onChange={(e, val) => setCurrentTab(val)}>
            <Tab label="Generate Payslips" />
            <Tab label="Approvals" />
            <Tab label="Report" />
          </Tabs>
        </Box>

        <TabPanel value={currentTab} index={0}>
          <GeneratePayslips />
        </TabPanel>

        <TabPanel value={currentTab} index={1}>
          <PayslipApprovals />
        </TabPanel>

        <TabPanel value={currentTab} index={2}>
          <PayslipReport />
        </TabPanel>

      </Paper>
    </Box>
  );
};

export default PayslipManagement;